import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { LatestDeviceDiagnosticsEffects } from './latest-device-diagnostics.effects';
import { latestDeviceDiagnosticsFeatureKey, latestDeviceDiagnosticsReducer } from './latest-device-diagnostics.reducer';

export const provideLatestDeviceDiagnosticsStore = () => [
  provideState(latestDeviceDiagnosticsFeatureKey, latestDeviceDiagnosticsReducer),
  provideEffects([LatestDeviceDiagnosticsEffects]),
];
